import React, { useState } from "react";
import "./AppointmentForm.css";
export default function AppointmentForm() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    type: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const scriptURL = "https://script.google.com/macros/s/AKfycbyt_GZjvpDzRslLZtuq9GjBB0q4eiqIhCsprincQxqAwbfEyaf18GYWGcojtsCKcRd1/exec"; // Replace with Apps Script URL
    try {
      const res = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(formData),
      });
      const result = await res.json();
      if (result.status === "success") {
        alert("Appointment saved! Opening WhatsApp...");
        window.open(result.whatsappUrl, "_blank");
      }
    } catch (error) {
      console.error("Thank you", error);
      alert("Thank you!");
    }
  };
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <div className="appointment-wrapper">
      {/* Left Content */}
      <div className="appointment-left">
        <h2>
          Get in touch to book <br /> your first appointment
        </h2>
        <p>
          Schedule a visit with Dr. Shruti Sagar at our Kompally clinic in
          minutes. Choose a convenient slot, share basic symptoms, and receive a
          confirmation with preparation tips whether for consultation,
          endoscopy, or follow-up.
        </p>
        <div className="contact-info">
          <div className="contact-item">
            <span className="contact-icon">📞</span>
            <span> +91 7569541532</span>
          </div>
          <div className="contact-item">
            <span className="contact-icon">✉️</span>
            <span>info@krisara.com</span>
          </div>
        </div>
      </div>
      {/* Right Form */}
      <div className="appointment-right">
        <form className="appointment-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <select
            name="type"
            value={formData.type}
            onChange={handleChange}
            required
          >
            <option value="">Select appointment Type</option>
            <option value="consultation">Consultation</option>
            <option value="endoscopy">Endoscopy</option>
            <option value="followup">Follow-up</option>
          </select>
          <textarea
            name="message"
            placeholder="Message"
            rows="4"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          <button type="submit">Submit Now</button>
        </form>
      </div>
    </div>
  );
}